<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command"></div>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="序号" prop="index" width="100"></el-table-column>
      <el-table-column align="center" label="用户ID" prop="userId"></el-table-column>
      <el-table-column align="center" label="用户名" prop="userName"></el-table-column>
      <el-table-column align="center" label="登陆日期" prop="loginDate"></el-table-column>
      <el-table-column align="center" label="登录IP" prop="loginIp"></el-table-column>
      <el-table-column align="center" label="登陆地点" prop="loginLocation"></el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { dateTimeToString, newtonsoftJsonToDate } from "../../tools/GeneralTool";

export default {
  name: "UserLoginHistory",
  data() {
    return {
      timer: null,
      tableData: [],
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 20,
      bridgeId: "",
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,
      historyScenarioCurrentGroupNameList: [],
      routeUserId: "",
    };
  },
  computed: {
    tableSpanRowIndexDict() {
      let clientMissionIdRowIndexListDict = {};
      for (let i = 0; i < this.tableData.length; i++) {
        const mission = this.tableData[i];
        if (clientMissionIdRowIndexListDict[mission.clientMissionId] === undefined) {
          clientMissionIdRowIndexListDict[mission.clientMissionId] = [i];
        } else {
          clientMissionIdRowIndexListDict[mission.clientMissionId].push(i);
        }
      }

      let result = {};
      for (let clientMissionId in clientMissionIdRowIndexListDict) {
        let rowList = clientMissionIdRowIndexListDict[clientMissionId];
        result[Math.min.apply(null, rowList)] = rowList.length;
      }

      return result;
    },
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;
    this.routeUserId = this.$route.query.userId;

    this.getDataCount();
    this.getDataList();

    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    bridgeId() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.bridgeId = this.bridgeId;
      this.$router.replace({ query: query });

      this.refreshData();
    },
    $route(route) {
      if (this.$route.query.userId !== this.routeUserId) {
        this.loading = true;
        this.routeUserId = this.$route.query.userId;

        this.getDataCount();
        this.getDataList();
      }
    },
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;
      this.getDataList();
    },
    getDataCount() {
      this.$http.get("/user/GetUserLoginRecordCount?userId=" + this.routeUserId).then((res) => {
        this.totalCount = res.data.count;
      });
    },
    getDataList() {
      let startIndex = (this.currentPage - 1) * this.pageSize;

      this.$http.get("/user/GetUserLoginRecordList?userId=" + this.routeUserId + "&start=" + startIndex + "&limit=" + this.pageSize).then((res) => {
        let dataList = res.data;
        this.startIndex = startIndex + 1;

        for (let dataItem of dataList) {
          startIndex += 1;
          dataItem.index = startIndex;
          dataItem.loginDate = dateTimeToString(newtonsoftJsonToDate(dataItem.loginDate), "YY年MM月dd日 HH:mm");
        }

        this.lastIndex = startIndex;
        this.tableData = dataList;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
    translateBridgeName(bridgeId) {
      for (let bridge of this.bridgeList) {
        if (bridge.id === bridgeId) {
          return bridge.name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    display: flex;
    // justify-content: flex-end;
    margin-bottom: 20px;
  }
  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}

.dialog-form-input {
  width: 80%;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
